<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow style="margin-top: 100px">
        <CCol lg="12">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <form
                  id="formSearchTrainee"
                  v-on:submit.prevent="searchTrainee"
                  method="POST"
                >
                  <h3 class="text-center">ตรวจสอบรายชื่อผู้สมัคร</h3>
                  <SltCenter />

                  <CRow>
                    <CCol col="6" class="text-left">
                      <button type="submit" class="btn btn-primary">
                        ค้นหา
                      </button>
                    </CCol>
                  </CRow>
                </form>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
        <CCol lg="12" style="margin-top: 20px">
          <CCard v-if="rows">
            <CCardHeader class="bg-dark text-white"
              ><strong>สรุปรายชื่อผู้สมัครเข้าร่วมอบรมของศูนย์</strong>

              <h3 class="text-warning">
                <strong>{{ rows[0].center_name }}</strong>
              </h3>
            </CCardHeader>
            <CCardBody>
              <vue-good-table
                :columns="columns"
                :rows="rows"
                :search-options="{ enabled: true }"
                :sort-options="{
                  enabled: true,
                  initialSortBy: { field: 'adminlogin_id', type: 'desc' },
                }"
                :pagination-options="{
                  enabled: true,
                  mode: 'page',
                  perPage: 25,
                }"
              >
                >
                <template slot="table-row" slot-scope="props"> </template>
              </vue-good-table>
            </CCardBody>
            <CCardFooter><div style="text-align: right">
              <!-----
            <button @click="onExport" class="btn btn-secondary">Export</button>
            ----->
          </div></CCardFooter>
          </CCard>
        </CCol>

      </CRow>
    </CContainer>

    <!----Modal Area---------------------------------------------------------->
    <CModal
      :show.sync="darkModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      size="lg"
      color="dark"
    >
      password หรือ username ไม่ถูกต้อง
      <template #header>
        <h6 class="modal-title">คำเตือน!!</h6>
        <CButtonClose @click="darkModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="darkModal = false" color="danger">Discard</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import SltCenter from "../components/SltCenter";
import XLSX from "xlsx"; // import xlsx
export default {
  name: "Login",
  components: { VueGoodTable, SltCenter, XLSX },
  data() {
    return {
      darkModal: false,

      columns: [
        {
          label: "#",
          field: "adminlogin_id",
          type: "number",
        },
        {
          label: "วันที่สมัคร",
          field: "adminlogin_stamp",
        },
        {
          label: "คำนำหน้า",
          field: "title_name",
        },
        {
          label: "ชื่อ - นามสกุล",
          field: "name",
        },
        {
          label: "โรงเรียน",
          field: "school_name",
        },
        {
          label: "หลักสูตร",
          field: "course_name",
        },
      ],
      rows: null,
      grandTotal: null,
    };
  },
  mounted() {},
  methods: {
    searchTrainee() {
      if (this.$store.state.selectedCenter == null) {
        alert("กรุณาเลือกศูนย์อบรม");
      } else {
        const form = document.getElementById("formSearchTrainee");
        const formData = new FormData(form);
        formData.append("txtAction", "getAllTeacher");
        formData.append("sltCenter", this.$store.state.selectedCenter.code);
        this.axios
          .post(this.$hostUrl + "php_action/userAPI.php", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            //console.log(response.data);
            this.rows = response.data.mainData;
          })
          .finally(() => {});
      }
    },
    onExport() {
      const dataWS = XLSX.utils.json_to_sheet(this.rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "export.xlsx");
    },
  },
  computed: {},
};
</script>
